// extracted by mini-css-extract-plugin
export var acitonButtons = "_m6-0";
export var additionalIcon = "_m6-f";
export var block = "_m6-1";
export var blockContent = "_m6-7";
export var blockDescription = "_m6-8";
export var blockIcon = "_m6-9";
export var blockTitle = "_m6-6";
export var border = "_m6-a";
export var center = "_m6-l";
export var edge = "_m6-b";
export var edgeLabel = "_m6-c";
export var edgePath = "_m6-d";
export var error = "_m6-e";
export var flowchart = "_m6-g";
export var flowchartContent = "_m6-h";
export var highlighted = "_m6-3";
export var hover = "_m6-4";
export var icon = "_m6-i";
export var left = "_m6-m";
export var navButton = "_m6-j";
export var navButtons = "_m6-k";
export var right = "_m6-n";
export var selected = "_m6-2";
export var small = "_m6-5";